import { Id, Loading, RenderView, usePublicBlockQueryShowById } from "@dgs/core";
import { FC } from "react";
import { useRegion } from "../region/RegionProvider";
import { useRegistrationToken } from "../shared/hooks/useRegistrationToken";

interface Props {
	blockId: Id | null;
}

export const RenderRegistrationBlock: FC<Props> = ({ blockId }) => {
	if (blockId === null) {
		return null;
	}

	return <RenderBlock blockId={blockId} />;
};
export const RenderBlock: FC<{ blockId: Id }> = ({ blockId }) => {
	const token = useRegistrationToken();
	const { regionId } = useRegion();
	const { block, isLoading } = usePublicBlockQueryShowById(blockId, {
		token: token || "",
		regionId: regionId ? `${regionId}` : "",
	});

	if (isLoading) {
		return <Loading />;
	}

	return block && <RenderView block={block} />;
};
